export const client_id = 'Tz5DWzLdcSSsCq2Dx9LTSaVVpqnN8eIp'
export const client_domain = 'dev-8ath7gqp12pi5vlt.us.auth0.com'